// Returns a callback that is debounced by the given time in ms.

export const debounce = <T extends (...args: Parameters<T>) => ReturnType<T>>(func: T, time = 16) => {
    let timeout: NodeJS.Timeout;
    return (...args: Parameters<T>) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), time);
    };
};
